(() => {
  const config = document.getElementById('mv-chat-enhancement');
  if (!config || config.dataset.ready) return;
  config.dataset.ready = 'true';
  const styleUrl = config.dataset.styleUrl;
  if (!styleUrl) return;
  const roots = new WeakSet();
  const buttons = new Set();
  const sync = () => buttons.forEach(button => {
    if (!button.isConnected) { buttons.delete(button); return; }
    button.toggleAttribute('data-mv-paused', document.hidden);
  });
  const decorate = root => {
    const button = root.querySelector('button[part~="activator"]');
    const icon = button?.querySelector('.activator__icon');
    if (!icon || button.classList.contains('mv-chat-upgraded')) return;
    const art = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    art.setAttribute('class', 'mv-chat-art');
    art.setAttribute('viewBox', '0 0 40 40');
    art.setAttribute('aria-hidden', 'true');
    art.setAttribute('focusable', 'false');
    art.innerHTML = '<g class="mvc-bubble"><path d="M10 10h16a6 6 0 0 1 6 6v9a6 6 0 0 1-6 6h-8l-7 5v-5a6 6 0 0 1-6-6v-9a6 6 0 0 1 5-6Z" fill="#23221f" stroke="#fff2cf" stroke-width="1.3" stroke-linejoin="round"/><g fill="#f3d28c"><circle class="mvc-dot" cx="13" cy="21" r="1.6"/><circle class="mvc-dot" cx="19" cy="21" r="1.6"/><circle class="mvc-dot" cx="25" cy="21" r="1.6"/></g></g><path class="mvc-spark" d="m33 2 1.6 4.4L39 8l-4.4 1.6L33 14l-1.6-4.4L27 8l4.4-1.6Z" fill="#fff8e8" stroke="#9d742b" stroke-width=".8" stroke-linejoin="round"/>';
    icon.append(art);
    button.classList.add('mv-chat-upgraded');
    buttons.add(button);
    sync();
  };
  const connect = () => {
    const shell = document.querySelector('shopify-chat')?.shadowRoot;
    const root = shell?.querySelector('shopify-agent-runtime')?.shadowRoot;
    if (!root) return false;
    if (roots.has(root)) return true;
    roots.add(root);
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = styleUrl;
    link.addEventListener('load', () => {
      decorate(root);
      new MutationObserver(() => decorate(root)).observe(root,{childList:true,subtree:true});
    }, {once:true});
    root.append(link);
    return true;
  };
  let attempts = 0;
  let timer;
  const retry = () => {
    clearInterval(timer);
    attempts = 0;
    if (connect()) return;
    timer = setInterval(() => { if (connect() || ++attempts >= 120) clearInterval(timer); }, 500);
  };
  retry();
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', retry);
})();
